import { render, staticRenderFns } from "./VLoading.vue?vue&type=template&id=03cd1368&"
import script from "./VLoading.vue?vue&type=script&lang=ts&"
export * from "./VLoading.vue?vue&type=script&lang=ts&"
import style0 from "./VLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports